import { render, staticRenderFns } from "./PrizeIterator.vue?vue&type=template&id=3ea32760&"
import script from "./PrizeIterator.vue?vue&type=script&lang=js&"
export * from "./PrizeIterator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports